<template>
  <div class="wrapper box  box_v">
    <page-head title="名单库" :showBack="false" :btn-list="btnList" :show-back="true" @handleBtn="handleBtn">
    </page-head>
    <div class="box_f1 box_v card-box">
      <Card dis-hover :padding="20">
        <i-form ref="formInline" inline label-position="top">
          <row :gutter="80">
            <i-col span="8">
              <FormItem label="姓名" prop="name">
                <Input v-model="name" placeholder="请输入姓名"/>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="身份证号" prop="cardno">
                <Input v-model="cardno" placeholder="请输入身份证号"/>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="手机号" prop="phoneNO">
                <Input v-model="phoneNO" placeholder="请输入手机号"/>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem :label="'何地回'+cityremark" prop="fromWhere">
                <Input v-model="fromWhere" placeholder="请输入从何地返回"/>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem :label="'回'+cityremark+'日期'" prop="backTime">
                <DatePicker v-model="backTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem label="有无发烧、咳嗽、感冒等症状" prop="symptomSelf">
                <Select v-model="symptomSelf" clearable>
                  <Option value="有">有</Option>
                  <Option value="无">无</Option>
                </Select>
              </FormItem>
            </i-col>
            <i-col span="8" v-if="isJiedao">
              
              <select-community ref="community" @communityChange="communityChange"></select-community>
              
            </i-col>
            <!--<i-col span="8" v-else>-->
            <!--<FormItem label="所属小区" prop="host">-->
            <!--<Select v-model="zoneId" class="input">-->
            <!--<Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>-->
            <!--</Select>-->
            <!--</FormItem>-->
            <!--</i-col>-->
            <!--<i-col span="8" v-if="isJiedao">-->
            <!--<FormItem label="所属小区" prop="host">-->
            <!--<Select v-model="zoneId" class="input" @on-open-change="selectZone">-->
            <!--<Option v-for="item in zoneList" :value="item.zoneId" :key="item.zoneId">{{ item.zoneName }}</Option>-->
            <!--</Select>-->
            <!--</FormItem>-->
            <!--</i-col>-->
          </row>
        </i-form>
      </Card>
      <Card dis-hover :padding="0" class="box_f1" style="margin-top: 20px">
        <div class="table-card">
          <div>
            <Button class="bkcc-btn del-btn" @click="delFangyi">删除</Button>
            <Button class="bkcc-btn del-btn" @click="$router.push({name:'addLibrary'})">新增</Button>
            <Button class="bkcc-btn del-btn" @click="importFile">导入</Button>
          </div>
          <Table border :columns="settingColumn" :data="fangyiList" :loading="isTableLoading"
                 @on-selection-change="selectTableItem" @on-row-click="clickRow"></Table>
          <page :total="total" @on-change="pageChange" class="page" :page-size="rows" :current="page" show-total/>
        </div>
      </Card>
    </div>
    <Modal
      v-model="detailModal"
      title="详情"
      width="660px"
      :footer-hide="true"
    >
      <div class="people-detail">
        <div><i class="detail-title">所属社区:</i>{{showItem.communityName}}</div>
        <div><i class="detail-title">姓名:</i>{{showItem.userName}}</div>
        <div><i class="detail-title">身份证:</i>{{showItem.idCardNO}}</div>
        <div><i class="detail-title">手机号:</i>{{showItem.phoneNO}}</div>
        <div class="box">
          <div class="detail-title">现居住地址:</div>
          <div>{{showItem.address}}</div>
        </div>
        <div><i class="detail-title">性别:</i>{{showItem.sex}}</div>
        <div><i class="detail-title">从何处返回:</i>{{showItem.fromWhere}}</div>
        <div><i class="detail-title">返回日期:</i>{{showItem.returnTime}}</div>
        <div><i class="detail-title">有无发烧、咳嗽、感冒等症状:</i>{{showItem.symptom}}</div>
        <div><i class="detail-title">是否密切接触者:</i>{{showItem.contact}}</div>
        <div class="box">
          <div class="detail-title">具体排查情况:</div>
          <div>{{showItem.checkWay}}</div>
        </div>
        <div class="box">
          <div class="detail-title">备注:</div>
          <div>{{showItem.remark}}</div>
        </div>
      </div>
    </Modal>
    <!--导入-->
    <Modal
      v-model="importModal"
      title="导入"
      width="660px"
      height="400px"
      :footer-hide="true"
    >
      <div class="note box">
        请上传符合模板要求的文件,支持.xlsx格式
        <a
          class="download"
          href="http://bkccshequ.oss-cn-beijing.aliyuncs.com/empty/2020/2/5/return_people_temp.xlsx"
          download="名单库模板"
        >下载名单库模板</a>
      </div>
      <Upload
        ref="upload"
        :show-upload-list="false"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :headers="header"
        :action="actionuri"
        :on-success="handleSuccess"
        :on-progress="handleProgress"
        :on-error="handleError"
      >
        <Button :loading="uploadLoading" type="primary">导入名单库</Button>
      </Upload>
    </Modal>
     <Modal title="确认" v-model="delModal" @on-cancel="cancelModal" @on-ok="delFangyiItem">
      <div>确认删除记录吗？删除后将无法恢复</div>
    </Modal>
  </div>
</template>

<script>
  var that
  import pageHead from '../../../components/head'
  import selectCommunity from '../../../components/selectCommunity'

  export default {
    name: 'peopelLibrary',
    components: {
      pageHead,
      selectCommunity
    },
    data() {
      return {
        name: '',
        communityId: 0,
        cardno: '',
        phoneNO: '',
        cityremark: '',
        btnList: [
          {
            name: '搜索',
            type: 'search',
            loading: false,
          }, {
            name: '重置',
            type: 'init',
            loading: false,
          }, {
            name: '导出',
            type: 'export',
            loading: false,
          }
        ],
        settingColumn: [],
        childShequ: [],
        fangyiList: [],
        isTableLoading: false,
        selectItem: [],
        page: 1,
        rows: 10,
        showItem: {},
        detailModal: false,
        total: 0,
        fromWhere: '',//从何地回京
        backTime: '',//回京日期
        symptomSelf: '',
        zoneId: '',
        zoneList: [],
        isLoadZoneList: false,
        importModal:false,
        header: {
          //令牌，为上传图片使用
          token: window.sessionStorage.getItem("token")
        },
        uploadLoading:false,
        actionuri:'',
        delId:'',
        delModal:false,
        //级联行政区域
        communityIdList:[]
      }
    },
    computed: {
      isJiedao() {
        return parseInt(this.$store.state.isJiedao);
      }
    },
    watch: {
      // communityId(newVal) {
      //   //点击重置的时候 communityId变为0，此时不应获取当前社区下的微社区
      //   //watch 只针对当前为街道，才会发生communityId变化
      //   if (newVal != 0) {
      //     this.getZoneList(newVal)
      //   } else {
      //     this.zoneList = [];
      //     this.zoneId = ''
      //   }
      // }
    },
    methods: {
      communityChange(value){
        this.communityId = value.communityId
        this.communityIdList = value.childrenIdList
        this.initFangyiList()
      },
      initTable() {
        this.settingColumn = [
          {
            type: 'selection',
            width: 70,
            align: 'center',
            fixed: 'left'
          }, 
          {
            title: "姓名",
            width: '95',
            resizable: true,
            key: "userName",
            fixed: 'left'
          },
          {
            title: "身份证号",
            key: 'idCardNO',
            resizable: true,
            width:'200',
          },
          {
            title: "联系电话",
            key: "phoneNO",
            resizable: true,
            width:'180',
          },
          {
            title: "行政区域",
            key: "communityName",
            resizable: true,
            width:'220',
          },
          {
            title: "何地回" + this.cityremark,
            key: "fromWhere",
            width:'180',
          },
          {
            title: "回" + this.cityremark + "日期",
            key: "returnTime",
            width:'180',
          },
          {
            title: "个人症状",
            width: '95',
            key: "symptom"
          },
          {
            title: "登记时间",
            key: "createTime",
            width:'240',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    that.fangyiList[params.index].createTime.substring(0,that.fangyiList[params.index].createTime.length-2)
                  )
                ]);
            }
          },
          {
            title: "操作",
            width: 240,
            fixed: 'right',
            render: function (h, params) {
              return h("div",
                [
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.getDetail(that.fangyiList[params.index].id)
                        }
                      }
                    },
                    "[详情]"
                  ),
                  h(
                    "span",
                    {
                      style: {
                        color: "#5e6d94",
                        marginLeft: "10px",
                      },
                      on: {
                        click: (e) => {
                          e.stopPropagation()
                          that.delItem(that.fangyiList[params.index].id)
                        }
                      }
                    },
                    "[删除]"
                  ),
                ]);
            }
          },
        ]
        this.getData()
      },
      initFangyiList() {
        this.page = 1
        this.getData()
      },
      getData() {
        var url = this.urlobj.peopleLibraryList
        this.$post(url, {
          pageNum: this.page,
          pageSize: this.rows,
          communityIdList: this.communityIdList,
          userName: this.name,
          idCardNO: this.cardno,
          phoneNO: this.phoneNO,
          fromWhere: this.fromWhere,
          returnTime: this.returnTime?this.$util.FormatDate(this.returnTime, "yyyy-MM-dd"):'',
          symptom: this.symptomSelf
        }).then(res => {
          this.total = res.total
          this.fangyiList = res.rows
        })
      },
      pageChange(val) {
        this.page = val;
        this.getData();
      },
      clickRow(value) {
        var id = value.id
        this.getDetail(id)
      },
      getDetail(id) {
        this.$get(this.urlobj.getLibraryDetail(id)).then(res => {
          this.detailModal = true
          this.showItem = res.rows[0]
        })
      },
      selectTableItem(value) {
        this.selectItem = value
      },
      handleBtn(type) {
        if (type == 'search') {
          this.initFangyiList()
        } else if (type == 'init') {
          this.name = ''
          this.communityId = 0
          this.cardno = ''
          this.phoneNO = ''
          this.returnTime = ''
          this.symptomSelf = ''
          this.communityIdList = []
          this.$store.state.isJiedao && (this.$refs.community.selectCommunity="");
          this.initFangyiList()
        } else if (type == 'export') {
          this.export()
        }
      },
       delItem(id) {
        this.delModal = true
        this.delId = id
        //this.delFangyiItem(this.fangyiList[index].id)
      },
      cancelModal(){

      },
      delFangyi() {
        var id = this.selectItem.map(item => item.id).join(',')
        if (!id) {
          this.$Message.warning('请选择要操作的记录')
          return
        }
        this.delModal = true
        this.delId = id
        //this.delFangyiItem(id)
      },
      delFangyiItem() {
        var url = this.urlobj.delLibrary
        this.$delete(url+'?idList=' + this.delId).then(res => {
          this.$Message.success('操作成功')
          this.initFangyiList()
        })
      },
      getCity(id) {
        this.$get(this.urlobj.getCity + 'id=' + id).then(res => {
          let cityid = res.rows[0].path.split('.')[2]
          this.getCityName(cityid)
        }).catch(e => {

        })
      },
      getCityName(id) {
        this.$get(this.urlobj.getCity + 'id=' + id).then(res => {
          this.cityremark = res.rows[0].remark || ''
          sessionStorage.setItem('cityremark', this.cityremark)
          this.initTable()
        }).catch(e => {

        })
      },
      //获取微社区列表
      getZoneList(id) {
        console.log('1111111111111111')
        this.isLoadZoneList = true
        let url = this.urlobj.zoneList
        this.$get(url, {
          communityId: id,
          zoneType:1,
          hasChild:1
        }).then(res => {
          this.isLoadZoneList = false
          this.zoneList = res.rows
        }).catch(e => {
          this.isLoadZoneList = false;
          console.log(e)
        })
      },
      //点击选择微社区列表时
      selectZone(val) {
        if (val) {
          //下拉框展开，且communityId为空
          if (!this.communityId) {
            this.$Message.info('请先选择社区')
          } else if (this.isLoadZoneList) {
            this.$Message.info('查询中,请稍后')
          }

        }
      },
      export() {
        let url = this.urlobj.exportLibrary  + '?communityId=' + this.$store.state.streetorcommunityid + '&token=' + this.$store.state.access_token
        window.open(url)
      },
      //点击导入按钮
      importFile() {
        this.importModal = true
      },
      handleProgress() {
        this.uploadLoading = true;
      },
      handleSuccess(response) {
        this.uploadLoading = false;
        this.importModal = false;
        this.$Message.success(response.message)
        this.initFangyiList()
      },
      handleError() {
        this.uploadLoading = false;
        this.importModal = false;
        this.$Message.error("导入失败");
      },
      // 下载模板
      downModel() {
        let url = this.urlobj.downQy + "?communityId=" + this.$store.state.streetorcommunityid;
        window.open(url);
      },
    },
    mounted() {
      that = this
      this.actionuri = this.urlobj.importLibrary + '?communityId=' + this.$store.state.streetorcommunityid;
      this.getCity(this.$store.state.streetorcommunityid)
      console.log(this.$store.state.isJiedao)
      if (parseInt(this.$store.state.isJiedao)) {
        this.getChildShequ();
      } else {
        // this.getZoneList(this.$store.state.streetorcommunityid)
      }

    }
  }
</script>

<style lang="less" scoped>
  /deep/ .ivu-form .ivu-form-item-label {
    font-size: 16px;
  }

  /deep/ .ivu-form-inline .ivu-form-item {
    display: block;
  }

  /deep/ .ivu-date-picker {
    display: block;
  }

  /deep/ .ivu-card-body {
    height: 100%;
  }

  .wrapper {
    height: 100%;
  }

  .card-box {
    margin: 0 20px 20px;
  }

  .table-card {
    padding: 20px 20px 80px;
    position: relative;
    height: 100%;
    text-align: right;
  }

  .del-btn {
    margin-bottom: 20px;
  }

  .people-detail div {
    font-size: 16px;
    margin-bottom: 10px
  }

  .detail-title {
    width: 120px;
    flex-shrink: 0;
    text-align: right;
    margin-right: 10px;
    display: inline-block;
    line-height: normal;
  }

  .page {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  .note {
    font-size: 16px !important;
    margin-bottom: 20px;
    .download {
      color: #ff7b44;
      text-decoration: underline;
      margin-left: 5px;
    }
  }
</style>
